import gql from 'graphql-tag';

import { query } from '@confluence/query-preloader-tools';
import { ONBOARDING_EXPERIENCES } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

const { IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED } = ONBOARDING_EXPERIENCES;

export const preloadLabelsMovedChangeboarding = () => {
	return query({
		query: gql`
			query preloadLabelsMovedChangeboardingQuery($key: String!) {
				onboardingState(key: [$key]) {
					key
					value
				}
			}
		`,
		variables: {
			key: IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED,
		},
	});
};
